import { forEachSchemaProp } from "./schema.helpers";
import selectn from "selectn";
import IAudit from "../interfaces/IAudit";
import IObservation from "../interfaces/IObservation";

const PERSON_WIDGET_LIST = ["personPicker"];

const isPersonField = (uiProps: { [key: string]: any }) => PERSON_WIDGET_LIST.includes(uiProps["ui:widget"])

export const auditToPersonIds = (audit: IAudit) => {
    return auditFormDataToPersonIds(audit.formData, audit.formSchema)
}

export const auditFormDataToPersonIds = (formData: IAudit["formData"], formSchema: IAudit["formSchema"]) => {
    if (!formSchema || !formSchema.schema.properties) {
        return [];
    };


    let idList: number[] = [];

    const { schema, uiSchema } = formSchema || {};

    if (!schema.properties) {
        return idList;
    };

    forEachSchemaProp(schema.properties, (path, property) => {
        const uiProperty = selectn(path, uiSchema) || {};

        if (isPersonField(uiProperty)) {
            const value = selectn(path, formData);

            if (value) {
                idList = idList.concat(value);
            };

            if (Array.isArray(value) && value.length) {
                idList = idList.concat(value);
            };
        }
    });


    return idList

};


export const observationToPersonIds = (formData: IObservation["formData"], formSchema: IObservation["formSchema"]) => {

    if (!formSchema || !formSchema.schema.properties) {
        return [];
    };

    let idList: number[] = [];

    const { schema, uiSchema } = formSchema || {};

    forEachSchemaProp(schema.properties as any, (path, property) => {
        const uiProperty = selectn(path, uiSchema) || {};

        if (isPersonField(uiProperty)) {
            const value = selectn(path, formData);

            if (value && typeof value === "number") {
                idList = idList.concat(value);
            };

            if (Array.isArray(value) && value.length) {
                idList = idList.concat(value);
            };
        }
    });
    return idList;
};
